/**
 * shows alert messages
 * @type {jQuery}
 */
var alertMessage = (function($){
  var settings = {
    autoClose: -1,
    type: "info"
  };
  /**
   * showing the alertmessage
   * @param  {string} str the text that needs to be shown in the alert message
   * @param  {} elm [description]
   * @return {[type]}     [description]
   */
  var show = function(str, elm){
    var alert = createAlert(str);
    $(elm).prepend(alert);

    //autoclose, if the setting autoclose > 0
    if(settings.autoClose > 0){
      setTimeout(function(){
        alert.remove();
      }, settings.autoClose);
    }
  };

  /**
   * the init settings for the alertMessages
   * @param  {[type]} args [description]
   * @return {[type]}      [description]
   */
  var setSettings = function(args){
    for (var key in args) {
      if (settings.hasOwnProperty(key)) {
        settings[key] = args[key];
      }
    }
  };

  /**
   * create the html for the alert
   * @param  {string} str the text of the alert
   * @return {object}     jquery of the alert html
   */
  var createAlert = function(str){
    var alert = '<div class="alertMessage alertMessage-'+settings.type+'">'.concat(
      '<span class="alertMessage__ico ico ico-'+getIconName(settings.type)+'"></span>',
      str,
      '</div>'

    );
    return $(alert);
  };

  /**
   * function that refactors the message type to a font awesome icon name
   * @param  {string} type message type
   * @return {iconname}      name of the fontawesome icon
   */
  var getIconName = function(type){
    switch(type){
      case 'error':
        return 'times';
      default:
        return 'info';
    }

  };

  return {
    show: show,
    settings: setSettings
  };
}(jQuery));

define("components/util/alertmessage", function(){});

